import script from "./OneOffItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OneOffItemModal.vue?vue&type=script&setup=true&lang=js"

import "./OneOffItemModal.vue?vue&type=style&index=0&id=fa648f40&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa648f40"]])

export default __exports__